var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z",
    fill: "#2B63D0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 15.4185C10.0736 15.7935 9.0609 16 8 16C6.9391 16 5.92643 15.7935 5 15.4185V11.5L1.82556 13.0872C0.685061 11.7046 0 9.93229 0 8C0 6.06771 0.685061 4.29543 1.82556 2.91278L5 4.5V0.581517C5.92643 0.206507 6.9391 0 8 0C9.0609 0 10.0736 0.206507 11 0.581517V4.5L14.1744 2.91278C15.3149 4.29543 16 6.06771 16 8C16 9.93229 15.3149 11.7046 14.1744 13.0872L11 11.5V15.4185Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 16C8.6906 16 9.36076 15.9125 10 15.748V9.5H15.8596C15.9518 9.01412 16 8.51269 16 8C16 7.48731 15.9518 6.98588 15.8596 6.5H10V0.252035C9.36076 0.087506 8.6906 0 8 0C7.3094 0 6.63924 0.087506 6 0.252035V6.5H0.140396C0.0482283 6.98588 0 7.48731 0 8C0 8.51269 0.0482284 9.01412 0.140396 9.5H6V15.748C6.63924 15.9125 7.3094 16 8 16Z",
    fill: "#E62048"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0001 5.49998L15.157 4.4215C15.0228 4.15349 14.8739 3.89407 14.7115 3.64429L11.0001 5.49998H13.0001zM1.00008 5.49998L.487549 5.24371C.59099 4.96186.709841 4.68744.843081 4.42148L3.00008 5.49998H1.00008zM5.00001 10.5L1.28865 12.3557C1.1262 12.1059.977329 11.8465.843065 11.5785L3.00001 10.5H5.00001zM15.5126 10.7562C15.4091 11.0381 15.2903 11.3125 15.157 11.5785L13.0001 10.5H15.0001L15.5126 10.7562z",
    fill: "#E62048"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 8C15.75 12.2802 12.2802 15.75 8 15.75C3.71979 15.75 0.25 12.2802 0.25 8C0.25 3.71979 3.71979 0.25 8 0.25C12.2802 0.25 15.75 3.71979 15.75 8Z",
    stroke: "#000",
    strokeOpacity: 0.1,
    strokeWidth: 0.5
  })));
}

export default SvgUk;